const Backbone = require('backbone');
require('common/_quantity.dust');
require('store/desktop/common/_quantity.dust');
var MAX_QTY = 9999,
	MIN_QTY = 1;

var QuantityView = Backbone.View.extend({
	initialize: function(options) {
		// Extend this.options so minQuantity and maxQuantity have default values
		// but are allowed to be overridden
		this.options = Object.assign(
			{
				useHiddenInput: false,
				minQuantity: options.type === 'quickAdd' ? 0 : MIN_QTY,
				maxQuantity: MAX_QTY
			},
			options
		);

		this.currentQuantity = parseInt(this.$('input').val(), 10);
		this.$('[disabled]').prop('disabled', false);

		if (options.disableOnChange) {
			this.listenTo(Backbone, 'quantityChange:complete', function(data) {
				if (data.itemKey === this.options.id || data.id === this.options.id) {
					this.$('button,input').prop('disabled', false);
				}
			});
		}

		let decrement = this.$('.js-decrement');
		this.$trashcanIcon = decrement.find('.js-trashcan');
		this.$minusIcon = decrement.find('.js-minus');
		this._updateMinusIcon();

		this.listenTo(this.options.cartItemModel, 'change:id', (_, id) => {
			this.options.id = id;
		});
	},

	events: {
		'click button': 'updateQuantity',
		'change input': 'updateQuantity',
		'click input': 'inputClicked'
	},

	updateQuantity: function(e) {
		e.preventDefault();
		const $input = this.$(`[name=qty]${this.options.useHiddenInput ? '' : ':visible'}`),
			hasIncrementClass = e.currentTarget.className.indexOf('js-increment') > -1,
			incrementValue = hasIncrementClass ? 1 : -1;
		let quantity = parseInt($input.val(), 10),
			increment = e.currentTarget.tagName === 'INPUT' ? 0 : incrementValue;
		const isIncrement = e.currentTarget.className.indexOf('js-increment') > -1 || this.currentQuantity < quantity;
		// If it's not a number, stick it to 1
		if (isNaN(quantity)) {
			quantity = 1;
		} else if (quantity > this.options.maxQuantity) {
			// If it's more than the max allowed, set it to the max
			quantity = this.options.maxQuantity;
		}

		// If the increment added to the quantity causes the quantity to exceed the
		// maximum quantity, don't add anything, otherwise add the increment
		quantity += increment + quantity > this.options.maxQuantity ? 0 : increment;

		// If the quantity is less than allowed, set it to the minimum
		if (quantity < this.options.minQuantity) {
			quantity = this.options.minQuantity;
		}
		if (this.options.disableOnChange) {
			this.$('button,input').prop('disabled', true);
		}

		// Set the value
		$input.val(quantity);

		Backbone.trigger(
			'quantity:changed',
			Object.assign(this.options, {
				quantity: quantity
			})
		);
		this.currentQuantity = quantity;

		this._handleOmniture(isIncrement);
		this._updateMinusIcon();
	},

	_updateMinusIcon: function() {
		if (this.$trashcanIcon.length) {
			if (this.currentQuantity === 1) {
				this.$minusIcon.addClass('ico-hide');
				this.$trashcanIcon.removeClass('ico-hide');
			} else {
				this.$trashcanIcon.addClass('ico-hide');
				this.$minusIcon.removeClass('ico-hide');
			}
		}
	},

	inputClicked: function(e) {
		e.preventDefault();
		if (!window.BCOM.device.isDesktop) {
			e.currentTarget.selectionStart = 0;
			e.currentTarget.selectionEnd = 10;
		}
	},

	getQuantity: function() {
		return this.currentQuantity;
	},

	setQuantity: function(quantity) {
		this.currentQuantity = quantity;
	},

	render: function() {
		this.$('input').val(this.currentQuantity);
	},
	_handleOmniture: function(isIncrement) {
		if (window.dataLayer.page === 'product:display' || window.dataLayer.page === 'product-pla:display') {
			Backbone.trigger('omniture:clicktracking', `quantity:${isIncrement ? 'incremented' : 'decremented'}`);
		}
	}
});

module.exports = QuantityView;
